<template>
  <header
    class="pbd-header"
    :class="{ 'pbd-header--sticky': isSticky }"
  >
    <transition name="header-fade" mode="out-in">

      <!-- =========================
           VERSIÓN NORMAL
           ========================= -->
      <div class="pbd-header__top" v-if="!isSticky" key="normal">
        <div class="pbd-header__title-row">

          <router-link
            :to="{ name: 'Cover', params: { lang: $store.state.i18n.lang } }"
            class="pbd-header__link"
          >
            <h1 class="pbd-header__brand">
              {{ $t('cover_title') || 'Barcelona Dades' }}
            </h1>
          </router-link>

          <div class="pbd-header__buttons">

            <!-- Links desktop -->
            <router-link v-if="currentLang === 'ca'" to="/qui-som">{{ $t('head_us') }}</router-link>
            <router-link v-if="currentLang === 'es'" to="/quienes-somos">{{ $t('head_us') }}</router-link>
            <router-link v-if="currentLang === 'en'" to="/about">{{ $t('head_us') }}</router-link>

            <router-link v-if="currentLang === 'ca'" to="/ajuda">{{ $t('head_help') }}</router-link>
            <router-link v-if="currentLang === 'es'" to="/ayuda">{{ $t('head_help') }}</router-link>
            <router-link v-if="currentLang === 'en'" to="/help-users">{{ $t('head_help') }}</router-link>

            <!-- Login -->
            <div
              v-if="!isLogined"
              class="login-button"
              @click="routeChange('Login')"
            >
              <div class="user-icon" />
              <span>{{ $t('login') }}</span>
            </div>

            <!-- Usuario logueado -->
            <div v-else class="logined-wrap" @click="toggleProfOp">
              <span>{{ loginedString }}</span>
              <div v-if="profOpOpen" class="absolute-wrap">
                <div class="op-wrap" @click="routeChange('Profile')">
                  <span>{{ $t('my_space') }}</span>
                </div>
                <div class="op-wrap" @click="logoutUserFunc">
                  <span>{{ $t('logout') }}</span>
                </div>
              </div>
            </div>

            <!-- Botón menú mobile -->
            <div
              class="header-button-wrapper"
              @click="toggleMobileMenu"
            >
              <div v-if="!mobileMenu" class="menu-icon" />
              <div v-else class="menu-close" />
            </div>

          </div>
        </div>
      </div>

      <!-- =========================
           VERSIÓN STICKY
           ========================= -->
      <div class="pbd-header__compact" v-else key="sticky">

        <div class="pbd-header__logo-row">
          <a
            :href="ajuntamentBrandUrl"
            class="pbd-header__logo-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              :src="logoAjbRounded"
              alt="Ajuntament de Barcelona"
              class="pbd-header__logo-img"
            />
          </a>
        </div>

        <div class="pbd-header__title-row">

          <router-link
            :to="{ name: 'Cover', params: { lang: $store.state.i18n.lang } }"
            class="pbd-header__link"
          >
            <span class="pbd-header__brand-compact">
              {{ $t('cover_title') || 'Barcelona Dades' }}
            </span>
          </router-link>

          <div class="pbd-header__buttons">

            <!-- Links desktop -->
            <router-link v-if="currentLang === 'ca'" to="/qui-som">{{ $t('head_us') }}</router-link>
            <router-link v-if="currentLang === 'es'" to="/quienes-somos">{{ $t('head_us') }}</router-link>
            <router-link v-if="currentLang === 'en'" to="/about">{{ $t('head_us') }}</router-link>

            <router-link v-if="currentLang === 'ca'" to="/ajuda">{{ $t('head_help') }}</router-link>
            <router-link v-if="currentLang === 'es'" to="/ayuda">{{ $t('head_help') }}</router-link>
            <router-link v-if="currentLang === 'en'" to="/help-users">{{ $t('head_help') }}</router-link>

            <!-- Login -->
            <div
              v-if="!isLogined"
              class="login-button"
              @click="routeChange('Login')"
            >
              <div class="user-icon" />
              <span>{{ $t('login') }}</span>
            </div>

            <!-- Usuario logueado -->
            <div v-else class="logined-wrap" @click="toggleProfOp">
              <span>{{ loginedString }}</span>
              <div v-if="profOpOpen" class="absolute-wrap">
                <div class="op-wrap" @click="routeChange('Profile')">
                  <span>{{ $t('my_space') }}</span>
                </div>
                <div class="op-wrap" @click="logoutUserFunc">
                  <span>{{ $t('logout') }}</span>
                </div>
              </div>
            </div>

            <!-- Botón menú mobile -->
            <div
              class="header-button-wrapper"
              @click="toggleMobileMenu"
            >
              <div v-if="!mobileMenu" class="menu-icon" />
              <div v-else class="menu-close" />
            </div>

          </div>
        </div>
      </div>

    </transition>

    <!-- ✅ MOBILE MENU FUERA DEL STICKY -->
    <!-- En móvil lo mantenemos montado mientras anima al cerrar -->
    <div v-show="isMobileMenuVisible" class="mobile-menu-wrap">
      <div class="mobile-menu-background" @click="toggleMobileMenu" />
      <div class="mobile-menu" :class="mobileMenuGrow && 'menu-grow'" @transitionend="onMobileMenuTransitionEnd">

        <div class="top-menu">
          <SearchInput :take-params="false" @search-pressed="searchHandler" class="option-search"/>

          <div class="options-wrap">
            <div class="menu-op" @click="mobileClickRoute('Cover')">
              <span>{{ $t('home') }}</span>
              <img class="chev-icon-img" :src="chevronIcon" alt="" />
            </div>

            <div v-if="isLogined" class="menu-op" @click="mobileClickRoute('Profile')">
              <span>{{ $t('my_space') }}</span>
              <img class="chev-icon-img" :src="chevronIcon" alt="" />
            </div>

            <div class="menu-op" @click="mobileClickRoute('About')">
              <span>{{ $t('head_us') }}</span>
              <img class="chev-icon-img" :src="chevronIcon" alt="" />
            </div>

            <div class="menu-op" @click="mobileClickRoute('Help')">
              <span>{{ $t('head_help') }}</span>
              <img class="chev-icon-img" :src="chevronIcon" alt="" />
            </div>
          </div>
        </div>

        <div>
          <div v-if="!isLogined" class="login-button" @click="mobileClickRoute('Login')">
            <div class="user-icon" />
            <span>{{ $t('login') }}</span>
          </div>
          <div v-else class="login-button" @click="logoutUserFunc">
            <span>{{ $t('logout') }}</span>
          </div>
        </div>

      </div>
    </div>

  </header>
</template>




<script>
import SearchInput from '@/components/SearchInput.vue'
import logoAjbRounded from '@/assets/logos/logo-ajuntament-barcelona-rounded.svg'
import chevronIcon from '@/assets/icons/icon-chevron-down-blue.svg'
import ClickOutside from 'vue-click-outside'
import { logoutUser } from '@/services/user-api'


export default {
  name: 'Header',
  components: {
    SearchInput,
  },
  directives: { ClickOutside },
  data() {
    return {
      isSticky: false,
      stickyEnabled: process.env.VUE_APP_STICKY_HEADER !== 'off',
      logoAjbRounded,
      chevronIcon,
      name: '',
      surname: '',
      headerMenuOpen: false,
      profOpOpen: false,
      bcnUserInput: '',
      mobileMenu: false,
      mobileMenuGrow: false,
      isMobileMenuVisible: false

    }
  },
  mounted() {
    if (this.stickyEnabled) {
      window.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()
    }
  },
  beforeDestroy() {
    if (this.stickyEnabled) {
      window.removeEventListener('scroll', this.onScroll)
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.i18n.lang
    },
    ajuntamentBrandUrl() {
      const lang = this.currentLang
      const urls = {
        ca: 'https://www.barcelona.cat/ca',
        es: 'https://www.barcelona.cat/es',
        en: 'https://www.barcelona.cat/en',
      }
      return urls[lang] || urls.ca
    },
    loginedString() {
      let str = ''
      str += this.name?.charAt()?.toUpperCase() || ''
      str += this.surname?.charAt()?.toUpperCase() || ''
      return str
    },
  },
  asyncComputed: {
    isLogined() {
      if (this.$store.state.user.name === '') {
        return this.$store.dispatch('checkLoginState').then(() => {
          if (this.$store.state.user.name) {
            this.name = this.$store.state.user.name
            this.surname = this.$store.state.user.surname
            return true
          }
          return false
        })
      } else if (this.$store.state.user.isLogged) {
        this.name = this.$store.state.user.name
        this.surname = this.$store.state.user.surname
        return true
      }
      return false
    },
  },
  watch: {
    mobileMenu(isOpen) {
      // OPEN (mobile):
      // 1) make wrapper visible
      // 2) next frame add class -> CSS transition animates in
      if (isOpen) {
        this.isMobileMenuVisible = true
        this.mobileMenuGrow = false
        requestAnimationFrame(() => {
          this.mobileMenuGrow = true
        })
        return
      }

      // CLOSE (mobile):
      // remove class -> CSS transition animates out.
      // when transition ends we will hide the wrapper.
      this.mobileMenuGrow = false
    },
  },
  methods: {
    onMobileMenuTransitionEnd(e) {
      // Only react to the panel's transform transition end
      if (e?.propertyName !== 'transform') return
      // When closing finished, hide wrapper
      if (!this.mobileMenu && !this.mobileMenuGrow) {
        this.isMobileMenuVisible = false
      }
    },
    logoutUserFunc() {
      logoutUser().then(() => {
        this.$store.dispatch('deleteUser').then(() => window.location.reload())
      })
    },
    mobileClickRoute(routeName) {
      if (this.$route.name !== routeName) {
        this.mobileMenu = false
        this.$router.push({ name: routeName })
      } else {
        this.mobileMenu = false
      }
    },

    onScroll() {
      if (!this.stickyEnabled) {
        this.isSticky = false
        return
      }
      const threshold = 120
      this.isSticky = window.scrollY > threshold
    },
    
    toggleheaderMenu() {
      this.headerMenuOpen = !this.headerMenuOpen
    },

    toggleProfOp() {
      this.profOpOpen = !this.profOpOpen
    },

    toggleMobileMenu() {
      // Toggle state; watcher handles animation/visibility
      this.mobileMenu = !this.mobileMenu
    },

    routeChange(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName })
      }
    },

    searchHandler(value) {
      if (value !== '') {
        if (this.$route.params.params !== value) {
          this.$router.push({ name: 'Search', params: { params: value } })
        }
      } else {
        this.$router.push({ name: 'Search' })
      }
    },
  }
}
</script>


<style lang="stylus" scoped>
.pbd-header
  position: relative
  z-index: 20
  background: #fff
  width: 100%
  padding: 0 16px
  box-sizing: border-box
  transition: all .2s ease

/* =========================
   CONTENEDORES IGUALES
   ========================= */

.pbd-header__top,
.pbd-header__compact
  width: 100%
  max-width: 1108px
  margin: 0 auto
  box-sizing: border-box

/* =========================
   VERSIÓN NORMAL
   ========================= */

.pbd-header__top
  display: flex
  flex-direction: column
  align-items: flex-start
  padding: 5px 0 8px

.pbd-header__brand
  font-size: 24px
  font-weight: 600
  margin: 0
  transition: transform .2s ease
  transform-origin: left center

.pbd-header--sticky .pbd-header__brand
  transform: scale(0.4)

@media (max-width: 768px)
  /* SOLO MÓVIL + SOLO AL HACER SCROLL (sticky): reducir más el logo Barcelona */
  .pbd-header--sticky .pbd-header__brand
    transform: scale(0.08)

/* =========================
   STICKY
   ========================= */

.pbd-header__compact
  padding: 10px 0 12px
  display: flex
  flex-direction: column

@media (max-width: 768px)
  /* SOLO MÓVIL + SOLO STICKY (scroll): compactar alturas/espacios */
  .pbd-header--sticky .pbd-header__compact
    padding: 2px 0 2px

.pbd-header__logo-row
  margin-bottom: 4px

.pbd-header__logo-link
  display: inline-flex

@media (max-width: 768px)
  /* SOLO MÓVIL + SOLO STICKY (scroll): menos separación entre logo y fila de título */
  .pbd-header--sticky .pbd-header__logo-row
    margin-bottom: -2px

.pbd-header__logo-img
  height: 32px
  width: auto

.pbd-header__title-row
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%

/* Mobile only: move buttons block (hamburger) to the left of the title */
@media (max-width: 768px)
  .pbd-header__title-row
    justify-content: flex-start
    gap: 12px

  /* SOLO MÓVIL + SOLO STICKY (scroll): reducir gaps internos (menu / titulo) */
  .pbd-header--sticky .pbd-header__title-row
    gap: 2px

  .pbd-header__buttons
    order: 1

  .pbd-header__link
    order: 2

.pbd-header__brand-compact
  padding-left: 8px
  font-size: 18px
  font-weight: 600
  /* allow transforms on the sticky title (mobile scaling) */
  display: inline-block
  transform-origin: left center

@media (max-width: 768px)
  /* SOLO MÓVIL + SOLO STICKY (scroll): menos padding a la izquierda del título */
  .pbd-header--sticky .pbd-header__brand-compact
    padding-left: 0
    margin-left: -2px

/* =========================
   BOTONES
   ========================= */

.pbd-header__buttons
  display: flex
  align-items: center
  gap: 24px

  a
    font-size: 14px
    color: $corporate_color
    text-decoration: none

    &:hover
      text-decoration: underline

/* =========================
   LOGIN BUTTON
   ========================= */

.login-button
  display: flex
  justify-content: center
  align-items: center
  padding: 5px 10px 5px 5px
  border: 1px solid #c5c7cb
  border-radius: 3px
  background-color: white
  cursor: pointer
  gap: 4px

  .user-icon
    m-icon("person-empty", 20)

  span
    font-size: 16px

  &:hover
    background-color: #f2f2f2

/* =========================
   USER CIRCLE
   ========================= */

.logined-wrap
  position: relative
  display: flex
  justify-content: center
  align-items: center
  width: 34px
  height: 34px
  border: 1px solid $grey-grey
  border-radius: 50%
  background-color: white
  cursor: pointer

  &:hover
    background-color: $light-grey

  span
    font-size: 14px
    color: $grey-dark
    font-weight: 400

  .absolute-wrap
    position: absolute
    top: calc(100% + 1px)
    right: 0
    z-index: 2
    display: flex
    flex-direction: column
    padding: 10px 0
    width: max-content
    border: 1px solid $grey
    border-radius: 6px
    background-color: white
    gap: 3px

    .op-wrap
      display: flex
      padding: 7px 10px
      cursor: pointer

      &:hover
        background-color: $bcn-very-light-grey

/* =========================
   BOTÓN MENÚ MOBILE
   ========================= */

.header-button-wrapper
  display: none
  justify-content: center
  align-items: center
  width: 32px
  height: 32px
  border-radius: 50%
  cursor: pointer

.menu-icon
  m-icon("menu", 22, $grey-dark)

.menu-close
  m-icon("close", 22, $grey-dark)

@media (max-width: 768px)
  /* Hamburguesa más grande solo en móvil */
  .menu-icon
    m-icon("menu", 32, $grey-dark)

  .menu-close
    m-icon("close", 32, $grey-dark)

/* =========================
   MOBILE MENU PANEL
   ========================= */

.mobile-menu-wrap
  position: absolute
  right: 0
  top: 100%
  width: 100vw
  height: calc(100vh - 100%)
  overflow: hidden

.mobile-menu-background
  position: absolute
  width: 100%
  height: 100%
  background-color: rgba(0,0,0,0.3)

.mobile-menu
  position: absolute
  right: 0
  background: white
  min-width: 300px
  height: 100vh
  padding: 25px 20px
  display: flex
  flex-direction: column
  justify-content: space-between
  box-shadow: 0 4px 80px rgba(0,0,0,0.5)
  /* desktop: keep as-is */
  transform: translateX(100%)

/* Mobile only: keep the same animation as before (transition only when .menu-grow toggles) */
@media (max-width: 768px)
  .mobile-menu
    left: 0
    right: auto
    will-change: transform
    transition: transform .25s ease-in-out
    transform: translateX(-100%)

    &.menu-grow
      transform: translateX(0)

/* =========================
   TRANSICIÓN ENTRE HEADERS
   ========================= */

.header-fade-enter-active,
.header-fade-leave-active
  transition: opacity .25s ease, transform .25s ease

.header-fade-enter
  opacity: 0
  transform: scale(.96)

.header-fade-leave-to
  opacity: 0
  transform: scale(.96)

/* =========================
   STICKY BEHAVIOUR
   ========================= */

.pbd-header--sticky
  position: sticky
  top: 0
  box-shadow: 0 2px 4px rgba(0,0,0,.12)

.option-search
  margin-bottom: 20px

.options-wrap
  display: flex
  flex-direction: column
  gap: 12px
  
.menu-op
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  padding: 8px 0
  color: $corporate_color

  span
    color: $corporate_color

  .chev-icon-img
    flex: 0 0 22px
    width: 22px
    height: 22px
    transform: rotate(-90deg)



/* =========================
   RESPONSIVE
   ========================= */

@media (max-width: 768px)

  /* SOLO MÓVIL + SOLO STICKY (scroll): reducir más el logo rojo (imagen) */
  .pbd-header--sticky .pbd-header__logo-img
    transform: scale(0.72)
    transform-origin: left center

  /* (revertimos el cambio anterior: NO reducir el texto "Barcelona Dades") */
  .pbd-header--sticky .pbd-header__brand-compact
    transform: none

  .pbd-header
    padding: 0 12px

  /* Oculta links desktop */
  .pbd-header__buttons a
    display: none

  /* Muestra hamburguesa */
  .header-button-wrapper
    display: flex

  .pbd-header__brand
    font-size: 20px

  .pbd-header__brand-compact
    font-size: 16px
  
  .pbd-header__buttons .login-button
    display: none

</style>
